import React from 'react'
import { connect } from 'react-redux'
import Camera from 'components/Camera'
import MultiImager from 'components/MultiImager'

const mapStateToProps = ({ cameras, createdAt }) => ({ cameras, createdAt })

class CamerasContainer extends React.Component {
  render() {
    const { cameras, createdAt } = this.props

    return (
      <div>
        { cameras.map(c =>
            c.isMultiImager
            ? <MultiImager key={'imagerComp' + createdAt + c.id} id={c.id} />
            : !c.imagerId && <Camera key={'camComp' + createdAt + c.id} id={c.id} />
          )
        }
      </div>
    )
  }
}

export default connect(mapStateToProps)(CamerasContainer)



// WEBPACK FOOTER //
// ./src/components/CamerasContainer/index.js